const setupFlutterBridge = () => {
  return new Promise((resolve, reject) => {
    const checkBridge = (attempts = 0) => {
      // 检测桥接是否完整（增加新方法检测）
      if (window.flutterBridge &&
          window.flutterBridge.getToken &&
          window.flutterBridge.navigateToLogin && window.flutterBridge.commonH5Callback) { // 添加新方法检测
        resolve(window.flutterBridge);
      } else if (attempts < 10) {
        setTimeout(() => checkBridge(attempts + 1), 200);
      } else {
        reject(new Error('Flutter bridge not available after 2 seconds'));
      }
    };
    checkBridge();
  });
};

// h5页面获取app中的token
const fromAppToken = async () => {
  try {
    // 1. 等待桥接就绪
    const bridge = await setupFlutterBridge();
    // 2. 获取token
    const appToken = await bridge.getToken();
      console.log('成功获取Token:', appToken, typeof appToken);
      return  appToken;
  } catch (err) {
      console.error('获取Token失败:', err);
      // 降级方案：尝试从URL参数获取
      // const urlToken = new URLSearchParams(window.location.search).get('token');
      // if (urlToken) {
      //   setAppToken(urlToken);
      // }
  }
};

const onPlatformInfo = async () => {
  try {
    const bridge = await setupFlutterBridge();
    const platformInfo = await bridge.getPlatformInfo();
      console.log('成功获取平台信息:', platformInfo, typeof platformInfo);
      return  platformInfo;
  } catch (err) {
      console.error('获取平台失败:', err);
  }
};
// 新增方法封装
const navigateToLogin = async (params = {}) => {
  try {
    const bridge = await setupFlutterBridge();
    await bridge.navigateToLogin(params);
    console.log('跳转登录页成功');
    return true;
  } catch (err) {
    console.error('跳转登录页失败:', err);
    // 降级方案：可以跳转到H5登录页
    return false;
  }
};

const commonH5Callback  = async (params) => {
  try {
    const bridge = await setupFlutterBridge();
    await bridge.commonH5Callback(params);
    console.log('-commonH5Callback 成功---');
    return true;
  } catch (err) {
    console.error('commonH5Callback --失败', err);
    // 降级方案：可以跳转到H5登录页
    return false;
  }
};

export const getAppToken  = async () => {
  const appToken  = await fromAppToken();
  return appToken;
}

export const appNavigateToLogin = navigateToLogin; // 新增方法
export const onCommonH5Callback = commonH5Callback; // 带参数的统一通信函数
export const getPlatformInfo = onPlatformInfo; // 带参数的统一通信函数
